<template> 
    <div class="page-main">
        <div class="main-title">MY APPLICATION</div>
        <div class="sub-title">{{scholarship.Name && scholarship.Name.split('|')[0].toUpperCase()}}</div>
        <div class="sub-title">{{scholarship.Name && scholarship.Name.split('|')[1].toUpperCase()}}</div>
        <v-row class="body-text" justify="center">
            <v-col cols="12" sm="10" md="8">
                <div>Applying for a GO Scholarship will take some time, but we promise it is worth it! Please put some thought into each answer and think about what you want to tell us. The application is split into a number of different sections. You can expand each one to read a little more about what we’re after. </div>
                <br />
                <div>As you work your way through each section, you’ll see the status change to <span class="body-text-btn" style="color: #ea7f1d;">IN PROGRESS</span>. Once you’ve answered all the questions in a section, it will be marked as <span class="body-text-btn" style="color: #d05927;">COMPLETE</span>. Don’t worry, you can still go back and change your answers before you click on Submit. </div>
                <br />
                <div>If you have any issues while completing your application, make sure you hit the <span class="body-text-btn" style="color: #4d4d4d;">SUPPORT</span> button and we’ll be in touch with help ASAP. </div>
                <br />
                <div style="margin-bottom: 30px;">Once every section is marked as <span class="body-text-btn" style="color: #d05927;">COMPLETE</span>, the submit button will be activated. Good luck!</div>

                <v-btn v-if="applicationStatus" class="button btn-font" @click="showSubmitDialog" :disabled="!completed || applicationStatus!=='in progress'" color="#ea7f1d" large>{{applicationStatus === 'in progress' ? 'SUBMIT APPLICATION' : 'APPLICATION SUBMITTED'}}</v-btn>

                <div v-if="applicationStatus === 'in progress'">
                    <div class="card" @click="toggleDesc(stage.Id)" v-for="stage in stages" :key="stage.Id">
                        <div class="card-up">
                            <img :class="'card-icon '+chooseIconClass(stage)" :src="chooseIcon(stage)" />
                            <div class="card-right">
                                <div>
                                    <div :class="'card-status '+chooseStatusClass(stage)">{{stage.Status__c&&stage.Status__c.toUpperCase() || 'NOT STARTED'}}</div>
                                    <div class="card-title">
                                        <span>{{stage.Name && stage.Name.toUpperCase()}}</span>
                                        <span v-if="stageDescToggles[stage.Id]">&nbsp;&nbsp;<img style="transform:rotate(180deg);" src="/profile_icon_arrow.svg" /></span>
                                        <span v-else>&nbsp;&nbsp;<img src="/profile_icon_arrow.svg" /></span>
                                    </div>
                                </div>
                                <v-btn @click.stop="toStage(stage.Id)" :disabled="stage.Category__c==='Interview' && stage.Status__c==='Completed'" :color="chooseBtnColor(stage)" class="card-btn btn-font" large>{{chooseBtnLabel(stage)}}</v-btn>
                            </div>
                        </div>
                        <div v-if="stageDescToggles[stage.Id]" class="card-down">
                            <span v-html="stage.Description__c"></span>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-dialog
              v-model="submitDialog"
              hide-overlayd
              persistent
              max-width="1000"
              width="80%"
        >
            <div class="dialog">
                <div class="declaration" v-html="scholarship['Declaration__c']"></div>
                <!-- <div class="signature">
                    <canvas width="600" height="140" id="signature" @mouseup="signature = true" @touchend="signature = true"></canvas>
                </div>
                <div class="clear-signature">
                    <span @click="clearSignature">Clear signature</span>
                </div> -->
                <div class="signature">
                    <v-checkbox
                        v-model="signature"
                        label="I agree with the terms above *"
                    ></v-checkbox>
                </div>
                <div class="dialog-btn">
                    <v-btn class="dialog-btn-back btn-font" @click="submitDialog = false;signature = false" outlined color="#4d4d4d" large>BACK</v-btn>
                    <v-btn class="dialog-btn-submit btn-font" @click="submitApp" :disabled="!signature || submitting" color="#ea7f1d" large>{{submitting ? 'SUBMITTING' : 'SUBMIT APPLICATION'}}</v-btn>
                </div>
            </div>
        </v-dialog>

        <div class="loadings">
            <div v-for="loading in loadings" :key="loading.id">
                <v-alert
                    elevation="2"
                    min-width="300"
                    max-width="500"
                >
                    <div class="loadings-message">{{loading.message}}</div>
                    <v-progress-linear
                        color="#ea7f1d"
                        rounded
                        indeterminate
                    ></v-progress-linear>
                </v-alert>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
// import SignaturePad from 'signature_pad'
import Client from '../client.js'

const ICON_MAP = {
    'undefined': '/app_myFinancialneed.svg',
    'Financial_need': '/app_myFinancialneed.svg',
    'Dream': '/app_myDreams.svg',
    'Culture': '/app_myCulture.svg',
    'Community': '/app_myCommunity.svg',
    'Xfactor': '/app_myXfactor.svg',
    'Interview': '/app_myInterview.svg',
    'Document': '/app_myDocuments.svg',
    'Referee': '/app_myReferees.svg',
}

export default {
    props: {
        application_id: [Number, String]
    },
    data() {
        return {
            stageDescToggles: {},
            submitDialog: false,
            submitting: false,
            signature: false,
        };
    },
    beforeDestroy() {
        // this.signaturePad && this.signaturePad.off();
    },
    computed: {
        scholarship() {
            const scholarship = this.$store.getters['stage/scholarship'];
            return scholarship || {};
        },
        applicationStatus() {
            const scholarship = this.$store.getters['stage/scholarship'];
            return scholarship ? scholarship['Scholarship_Application__c.Status__c'].toLowerCase() : '';
        },
        completed() {
            return this.stages.length > 0 && this.stages.every(s => s.Status__c && s.Status__c.toLowerCase() === 'completed');
            // return true
        },
        stages() {
            return this.$store.getters['stage/stages'];
        },
        loadings() {
            return this.$store.getters['loading/loadings'];
        }
    },
    methods: {
        // clearSignature() {
        //     this.signaturePad.clear();
        //     this.signature = false;
        // },
        showSubmitDialog() {
            this.submitDialog = true;
            // setTimeout(() => {
            //     const canvas = document.getElementById('signature');
            //     this.signaturePad = new SignaturePad(canvas);
            // }, 500)
        },
        chooseBtnLabel(stage) {
            switch(stage.Status__c && stage.Status__c.toLowerCase()) {
                case 'completed':
                    return stage.Category__c === 'Interview' ? `FINISHED` : `EDIT`
                case 'in progress':
                    return `EDIT`
                case 'not started':
                default:
                    return `LET’S GO`
            }
        },
        chooseBtnColor(stage) {
            switch(stage.Status__c && stage.Status__c.toLowerCase()) {
                case 'completed':
                    return '#d05927'
                case 'in progress':
                case 'not started':
                default:
                    return '#ea7f1d'
            }
        },
        chooseIconClass(stage) {
            switch(stage.Status__c && stage.Status__c.toLowerCase()) {
                case 'in progress':
                    return 'filter-in-progress'
                case 'completed':
                    return 'filter-complete'
                case 'not started':
                default:
                    return ''
            }
        },
        chooseStatusClass(stage) {
            switch(stage.Status__c && stage.Status__c.toLowerCase()) {
                case 'in progress':
                    return 'status-in-progress'
                case 'completed':
                    return 'status-complete'
                case 'not started':
                default:
                    return ''
            }
        },
        chooseIcon(stage) {
            return ICON_MAP[stage.Category__c];
        },
        toggleDesc(stageId) {
            const current = this.stageDescToggles[stageId];
            this.stageDescToggles = {
                ...this.stageDescToggles,
                [stageId]: !current
            }
            console.log(this.application_id)
        },
        toStage(stageId) {
            this.$router.push({
                name: 'stage.block',
                params: {
                    stage_key: stageId
                }
            });
        },
        async submitApp() {
            this.submitting = true;
            const client = Client();
            try {
                await axios.all([
                    client.patch(`/applications/${this.application_id}?submit=1`, {status: 2})  
                ]);
                // client.patch(`/references/${this.application_id}`);
                this.submitting = false
                this.submitDialog = false;
                this.$router.push({
                    name: 'application.finish'
                });
            } catch(e) {
                this.submitting = false
                console.log(e)
            }
            
        },
        stageProgress(stageKey) {
            if(this.progress.length === 0) {
                return 0;
            }
            const progress = this.progress.find(item => item.stage_key === stageKey);
            return Math.ceil(progress.answeredNum / progress.totalNum * 100);
        },
        showStageButton(stageKey) {
            const sp = this.stageProgress(stageKey);
            if(stageKey === 'online_interview' && sp === 100) {
                return 'DONE';
            }
            return sp ? 'EDIT' : 'START';
        },
        navigateToStage: function(stage) {
            this.$router.push({
                name: "stage.start",
                params: {
                    stage_key: stage.key,
                    application_id: this.application_id
                }
            });
            return;
        },
        startFinancialNeed() {
            this.$router.push({
                name: "stage.start",
                params: {
                    stage_key: 'financial_need',
                    application_id: this.application_id
                }
            });
            return;
        },
        toDashboard() {
            this.$router.push({
                name: "home.dashboard"
            });
            return;
        }
    }
}
</script>
<style lang="scss" scoped>
.body-text-btn {
    font-family: $btn-font;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.7px;
}
.main-title {
    font-family: $body-font-family;
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 4px;
    text-align: center;
    margin-bottom: 30px;
}
.sub-title {
    font-family: $body-font-family;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 3.2px;
    text-align: center;
    margin-bottom: 20px;
}
.body-text {
    font-family: $secondary-font;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
}
.button {
    width: 100%;
    color: white;
    font-family: $btn-font;
    margin-bottom: 30px;
}
.card {
    border: solid 1px #a5a5a5;
    background-color: #ffffff;
    padding: 20px;
    cursor: pointer;
}
.card-up {
    display: flex;
    align-items: center;
}
.card-down {
    padding-top: 20px;
    font-family: $secondary-font;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
}
.card-icon {
    flex: initial;
    padding-right: 30px;
    width: 76px;
    height: 48px;
}
.card-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
}
.card-status {
    font-family: $btn-font;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 0.75px;
    color: #9a9a9a;
    margin-bottom: 14px;
}
.card-title {
    font-family: $body-font-family;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 2.67px;
}
.card-btn {
    color: white;
    flex-basis: 150px;
}
.filter-in-progress {
    filter: invert(43%) sepia(26%) saturate(2535%) hue-rotate(343deg) brightness(90%) contrast(88%);
}
.filter-complete {
    filter: invert(68%) sepia(95%) saturate(3068%) hue-rotate(347deg) brightness(94%) contrast(95%);
}
.status-in-progress {
    color: #ea7f1d;
}
.status-complete {
    color: #d05927;
}
.dialog {
    padding: 30px;
    background-color: white;
}
.dialog-btn {
    display: flex;
    align-items: center;
}
.dialog-btn-back {
    flex: initial;
    margin-right: 30px;
}
.dialog-btn-submit {
    flex: 1;
    color: white;
}
.signature {
    margin-bottom: 10px;
    text-align: center;
    font-family: Hind;
    display: flex;
    justify-content: center;
}
#signature {
    border: solid 1px #979797;
}
.clear-signature {
    direction: rtl;
    font-family: $secondary-font;
    margin-bottom: 40px;
    >span {
        font-size: 14px;
        line-height: 1.43;
        color: #ea7f1d;
        text-decoration: underline;
        cursor: pointer;
    }
}
.declaration {
    margin-bottom: 10px;
    font-family: $secondary-font;
}
.loadings {
    position: fixed;
    bottom: 10px;
    left: 10px;
    opacity: .8;
}
.loadings-message {
    font-family: $secondary-font;
    margin-bottom: 5px;
}

</style>
